import { Fab, Grid, Paper, Tab, Tabs, Theme, Tooltip, Typography } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import merge from 'deepmerge';
import { isBrowser } from 'react-device-detect';
import React, { setGlobal, useGlobal } from 'reactn';
import MissingParameters from '../../components/Errori/MissingParameters';
import IForfettariAppBar from '../../appBar/IForfettariAppBar';
import ProgressBar from '../../progress/ProgressBar';
import TabPanel from '../../components/TabPanel';
import '../../css/media-query-styles.css';
import { IGlobalState, initialStateBudget } from '../../states/GlobalState';
import { loggaAccesso } from '../../services/common';
import SchedaBudgetDataClass, { IMPRESA, IsRegimeForfetario, IsRegimeNormale, PROFESSIONE } from '../../states/BudgetState';
import Auth from '../../types/auth';
import { Applicazioni, DefaultInputProps, TabIForfettari } from '../../types/types';
import { tabsSchedaBudget } from '../../types/constants';
import ContoEconomicoDittaSocieta from './ContoEconomicoDittaSocieta';
import ContoEconomicoProfessionista from './ContoEconomicoProfessionista';
import Forfetari from './Forfetari';
import HelpSchedaBudget from './HelpSchedaBudget';
import InformazioniCosti, { SchedaBudgetInputProps } from './InformazioniCosti';
import ComputerIcon from '@material-ui/icons/Computer';
import { API_elaboraSchedaBudgetGlobal, verifyUser } from '../../utils/functions';
import { useLogger } from '../../logger';
import { useHistory } from "react-router-dom";
import Main from '../../components/main';
import { motion } from 'framer-motion';
import { fabVariants } from '../../animation/variants';

function reducerSchedaBudget(state: SchedaBudgetDataClass, action: any = undefined) {
  let s: SchedaBudgetDataClass;
  switch (action.type) {
    case 'setLoading':
      s = {
        ...state,
        loading: action.value
      };
      return s;
    case 'reset':
      return initialStateBudget;
    case 'set':
      s = { ...action.value };
      let newState = merge(initialStateBudget, s);
      return newState;
    case 'count':
      s = { ...action.value };
      let countState = merge(state, s);
      return countState;
    case "changeInformazioniCostiBudget":
      s = {
        ...state,
        informazioniCostiDiAvvio: {
          ...state.informazioniCostiDiAvvio,
          [action.name]: action.value
        }
      }
      return s;
    case "changeIscrizioneRegistroImprese":
      s = {
        ...state,
        iscrizioneRegistroImprese: {
          ...state.iscrizioneRegistroImprese,
          [action.name]: action.value
        }
      }
      return s;
    case "changeIscrizioneImpreseArtigiane":
      s = {
        ...state,
        iscrizioneImpreseArtigiane: {
          ...state.iscrizioneImpreseArtigiane,
          [action.name]: action.value
        }
      }
      return s;
    case "changeContoEconomicoProfessionista":
      s = {
        ...state,
        contoEconomicoProfessionista: {
          ...state.contoEconomicoProfessionista,
          [action.name]: action.value
        }
      }
      return s;
    case "changeContoEconomicoDittaSocieta":
      s = {
        ...state,
        contoEconomicoDittaSocieta: {
          ...state.contoEconomicoDittaSocieta,
          [action.name]: action.value
        }
      }
      return s;
    case "changeInail":
      s = {
        ...state,
        inail: {
          ...state.inail,
          [action.name]: action.value
        }
      }
      return s;
    case "resetInail":
      s = {
        ...state,
        inail: {
          ...initialStateBudget.inail,
        }
      }
      return s;
    case "changeCCIAA":
      s = {
        ...state,
        dirittiCCIAA: {
          ...state.dirittiCCIAA,
          [action.name]: action.value
        }
      }
      return s;
    case "resetChecksCCIAA":
      s = {
        ...state,
        dirittiCCIAA: {
          ...state.dirittiCCIAA,
          B8_check: false,
          B9_check: false,
          B10_check: false,
          B11_check: false,
          B12_check: false,
          B13_check: false,
          B14_check: false,
          B15_check: false,
          [action.name]: action.value
        }
      }
      return s;
    case "changeImposteContributi":
      s = {
        ...state,
        imposteContributi: {
          ...state.imposteContributi,
          [action.name]: action.value
        }
      }
      return s;
    case "changeForfetari":
      s = {
        ...state,
        forfetari: {
          ...state.forfetari,
          [action.name]: action.value
        }
      }
      return s;
    case "changeGruppoDiSettore":
      s = {
        ...state,
        forfetari: {
          ...state.forfetari,
          gruppoDiSettore: {
            D46_reddito: action.value.D46_reddito,  // attenzione
            gruppo: action.value.gruppo
          }
        }
      }
      return s;
    default:
      throw new Error();
  }
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
    appBar: {
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    appBarShift: {
      // width: `calc(100% - ${drawerWidth}px)`,
      // marginLeft: drawerWidth,
      // transition: theme.transitions.create(['margin', 'width'], {
      //   easing: theme.transitions.easing.easeOut,
      //   duration: theme.transitions.duration.enteringScreen,
      // }),
    },
    tabsBar: {
      boxShadow: "0px 4px 7px 3px #ccc",
      position: "fixed",
      zIndex: 1000,
      // overflow: 'auto',
      // overflow: 'auto'      
      // width: "100%",
      // marginTop: ""
      // transition: theme.transitions.create(['margin', 'width'], {
      //   easing: theme.transitions.easing.sharp,
      //   duration: theme.transitions.duration.leavingScreen,
      // }),
    },
    tabsBarShift: {
      boxShadow: "0px 4px 7px 3px #ccc",
      position: "fixed",
      zIndex: 1000,
      // marginTop: '12px',
      // overflow: 'auto'
      // width: `calc(100% - ${drawerWidth}px)`,
      // marginLeft: drawerWidth,
      // transition: theme.transitions.create(['margin', 'width'], {
      //   easing: theme.transitions.easing.easeOut,
      //   duration: theme.transitions.duration.enteringScreen,
      // }),
    },
    tabColorati: {
      transitionTimingFunction: 'ease-in',
      transition: 'background 0.5s',
      '&:hover': {
        background: theme.palette.secondary.main,
      },
      flex: '0 1 auto',
      // width: ''
    },
    testoColorato: {
      '&:hover': {
        color: '#fff'
      }
    },
    button: {
      backgroundColor: 'rgba(0, 161, 216, 0.8)', // blue[100],
      color: '#fff',
      '&:hover': {
          backgroundColor: 'rgba(0, 161, 216, 1.0)'
      },
      '&:pressed': {
          backgroundColor: 'rgba(0, 161, 216, 1.0)'
      }
    },
    // Media query for the tabs menu, sotto i 400px siamo in flex start
    justifyTabs: {
      paddingTop: '20px',
      [theme.breakpoints.down('sm')]: {
        justifyContent: 'flex-start',        
      },
      [theme.breakpoints.up('md')]: {
        justifyContent: 'center',
      },
      [theme.breakpoints.up('lg')]: {
        justifyContent: 'center',
      },
    },
  }),
);

export default function IBudgetHomePage() {
  const [stateBudget, dispatchBudget] = React.useReducer(reducerSchedaBudget, initialStateBudget);
  // eslint-disable-next-line
  const [identity] = useGlobal<IGlobalState, 'identity'>('identity');
  const [,setApplication] = useGlobal<IGlobalState, 'application'>('application');
  const [global] = useGlobal<IGlobalState>();
  const [userLogged,setUserLogged] = useGlobal<IGlobalState, 'userLogged'>('userLogged');
  const [tab, setTab] = React.useState(TabIForfettari.Dati as number);
  const [open, setOpen] = React.useState(false);
  const logger = useLogger({key: 'identity'});
  const history = useHistory();
  const [title, ] = useGlobal<IGlobalState, 'title'>('title');
  
  let apptabs = tabsSchedaBudget;

  // const username = Auth.getUsername(global);
  const username = identity?.Username!;
  console.log('Sono in HOME BUDGET CON USERNAME: ' + username);
  // if (auth && auth.user)
  //   console.log('Access token: ' + auth.user!.access_token)

  const handleChangeBudget = (type: string, name: string, value: any) => {
    dispatchBudget({ type, name, value });
  }

  function handleTabChange(event: React.ChangeEvent<{}>, newValue: TabIForfettari) {
    setTab(newValue);
  }

  function verifyApplicationPrincipal() {
    if (!identity || identity.ApplicationBudget !== true) {
      logger.error('Diritto mancante sulla applicazione Budget');
      history.push('/');
    }
  }
  
  function a11yProps(index: any) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  //HACK vmorell 20210303  
  function handleClickBudget4u(stateBdg: SchedaBudgetDataClass) {
    console.log('ho lanciato il calcolo conv Srl con lo stato: ' + JSON.stringify(stateBdg))
    let props: SchedaBudgetInputProps = {state: stateBdg, handleChange: handleChangeBudget, username: username};

    API_elaboraSchedaBudgetGlobal(props, global);

  }
  //END HACK vmorell

  function handleResetState() {
    dispatchBudget({ type: 'reset' });
  }

  function handleLoadState(newState: SchedaBudgetDataClass, applicazione: number) {
    dispatchBudget({ type: 'set', value: newState });
  }
    
  React.useEffect(() => {

    setApplication(Applicazioni.Budget4u);
    if (identity) {
      console.log('Identity HOME BUDGET is set ');
      verifyApplicationPrincipal();    
    }
    
    if (username && username !== '' && (!userLogged || userLogged !== username)) {
      console.log('Loggo in Tabella login e verifico utente');
      setUserLogged(identity?.Username!);
      loggaAccesso(Auth.getProvincia(global)!, identity?.Username!, Applicazioni.Budget4u, global).then(res => {
        console.log('Loggo ritorna: ' + res);
        if (res === false) {
          global.auth.userManager.signoutRedirect();        
        }
      })
      
    } else {
      console.log('Loggo non eseguito');
    }
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [username]);
  
  const classes = useStyles();
  let isloading = stateBudget.loading;
  
  return (
    <div style={{ backgroundColor: "#e3e3e3", minHeight: "100vh" }}>
      <IForfettariAppBar title={title} handleLoad={() => {}} stateSkBudget={stateBudget} handleChange={handleTabChange}
         loadState={handleLoadState} resetState={handleResetState} apptabs={apptabs}></IForfettariAppBar>
        <ProgressBar isOpen={isloading}></ProgressBar>
        <Main>
          {/* Main content */}
          <Grid
            className={classes.justifyTabs}
            container
            direction="row"
            alignItems="center"        
          >
            <Paper className={clsx(classes.tabsBar, {
              [classes.tabsBarShift]: open && isBrowser,
            })}>
              <Tabs value={tab} onChange={handleTabChange} textColor="secondary" scrollButtons='on'>
                {
                  apptabs.map((text, index) => (
                    <Tab className={classes.tabColorati} key={index} label={<Typography className={classes.testoColorato} variant="button" color={index === 0 ? "primary" : "secondary"}>{text}</Typography>}{...a11yProps(index)}></Tab>
                  ))
                }
              </Tabs>
            </Paper>
          </Grid>
          <Grid
            id="print"
            container
            direction="column"
            justify="flex-start"
            alignItems="center"
          >
              <React.Fragment>
                <TabPanel show={tab === 0} index={0}>
                  <Grid
                    className={clsx(classes.appBar, {
                      [classes.appBarShift]: open && isBrowser,
                    })}
                    container
                    direction="column"
                    justify="flex-start"
                    alignItems="center"
                  >
                    <InformazioniCosti state={stateBudget} handleChange={handleChangeBudget}></InformazioniCosti>
                  </Grid>
                </TabPanel>
                {IsRegimeForfetario(stateBudget) === true ? <p></p> :
                  (<TabPanel show={tab === 1} index={1}>
                    <Grid
                      className={clsx(classes.appBar, {
                        [classes.appBarShift]: open && isBrowser,
                      })}
                      container
                      direction="column"
                      justify="flex-start"
                      alignItems="center"
                    >
                      {
                        IMPRESA(stateBudget) ?
                          <ContoEconomicoDittaSocieta state={stateBudget} handleChange={handleChangeBudget}></ContoEconomicoDittaSocieta>
                          : PROFESSIONE(stateBudget) ?
                            <ContoEconomicoProfessionista state={stateBudget} handleChange={handleChangeBudget}></ContoEconomicoProfessionista>
                            : <MissingParameters campo="Tipologia" pagina="COSTI DI AVVIO"></MissingParameters>
                      }
                    </Grid>
                  </TabPanel>)
                }
                {IsRegimeNormale(stateBudget) ? <p></p> :
                  (<TabPanel show={tab === 2} index={2}>
                    <Grid
                      className={clsx(classes.appBar, {
                        [classes.appBarShift]: open && isBrowser,
                      })}
                      container
                      direction="column"
                      justify="flex-start"
                      alignItems="center"
                    >
                      {
                        IMPRESA(stateBudget) || PROFESSIONE(stateBudget) ?
                          <Forfetari state={stateBudget} handleChange={handleChangeBudget}></Forfetari>
                          : <MissingParameters campo="Tipologia" pagina="COSTI DI AVVIO"></MissingParameters>
                      }
                    </Grid>
                  </TabPanel>)
                }
                <TabPanel show={tab === 3} index={3}>
                  <Grid
                    className={clsx(classes.appBar, {
                      [classes.appBarShift]: open && isBrowser,
                    })}
                    container
                    direction="column"
                    justify="flex-start"
                  >
                    <HelpSchedaBudget ></HelpSchedaBudget>
                  </Grid>
                </TabPanel>
                {tab !== 3 ?
                (<Tooltip title="Calcola Budget4u">
                    <Fab 
                        className={classes.button}
                        style={{position: 'fixed', bottom: 20, right: 20}}
                        color="inherit"
                        size="large"
                        onClick={(e: any) => handleClickBudget4u(stateBudget)}
                    >
                      <motion.div
                        variants={fabVariants}
                        initial="hidden"
                        animate="visible"
                        style={{verticalAlign: 'middle'}}
                      >
                        <ComputerIcon />
                      </motion.div>
                    </Fab>
                </Tooltip>)
                : null}
              </React.Fragment>
            </Grid>
        </Main>
    </div>
  );
}

